module.exports = __webpack_public_path__ + "media/images/ticbali-square-f4a2ba3745667507278e1747e3bbdcbf.png";